import React, { PureComponent } from 'react';
import FollowUpDrawer from "@components/FollowUp/FollowUpDrawer";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import Lang from "@components/Lang/Lang";

/**
 * 跟进按钮
 *
 * */
export default class FollowBtn extends PureComponent {
    static defaultProps = {
        row:{},
        labelType:"1010",//	1010:新客标签 1020:成交客户标签
        buyerId:null,//采购商 id,无时用row 对象的id
        buyerInternalId:null//潜在客户id
    };
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        }
    }
     showDrawer = (flag) => {
         this.setState({
             open:flag
         })
        if(flag){
            if (this.childRefDrawer) {
                this.childRefDrawer.getCustomer()
            }
        }
    };
    refreshPage(dat){
       if(this.props.refreshPage){
           this.props.refreshPage(dat)
       }
    }
    childRef = (ref) =>  this.childRefDrawer = ref;
    render() {
        const {row,labelType,buyerId=null,children,buyerInternalId} = this.props;
        const {open=false,disable} = this.state;
        return (
            <>
               {children?<span className={"cursor-p"} onClick={()=>this.showDrawer(true)}>
                {children}
            </span>:<AuthBtn icon={"ri-draft-line"} tips = {disable?{id:"ZanWuQuanXian",default:"暂无权限"}:Lang({id:"GenJin",default:"跟进"})}
                         showDot={row.needFollowToday===1}//为1  今天需要跟进
                         onClick={disable?"":()=>this.showDrawer(true)}
                         className={disable?"btnDisabled":"blueIconTips"}  />}
                <FollowUpDrawer buyerId={buyerId||row.id}
                                buyerInternalId={buyerInternalId}
                                labelType={labelType}
                                onRef={this.childRef}
                                visibleFollowUpDrawer={open}
                                showDrawer={(flag)=>this.showDrawer(flag)}
                                refreshPage={(dat)=>this.refreshPage(dat)}
                />
            </>
        );
    }


};
